{
	"filter": {
		"timeframe": "Timeframe",
		"customer": "Customer",
		"plant": "Plant",
		"product": "Product",
		"invoiceLineItemNumber": "Invoice / line item number",
		"transactionId": "Transaction ID",
		"epdId": "EPD ID",
		"status": "Status"
	},
	"statusLabels": {
		"None": "Unflagged",
		"Flagged": "Flagged",
		"Resolved": "Resolved"
	},
	"clearAllFilters": "Clear all filters"
}
